module.exports = __webpack_public_path__ + "src/shared-components/customer-search/clear.bb8edd03a6c0597712fcbf1a78b48a55.svg";